import { getGenericStore } from './genericStore';

const blocklyEventStore = Object.create(getGenericStore({ blocklyWorkspace: null, blocklyEvent: null }));
export default blocklyEventStore;